import * as React from 'react';

import styles from './label.module.css';

type Props = {
    children?: React.ReactNode;
};

/*
 * Component used when a label and label styling is desired, but using
 * an actual <label> breaks HTML accessibility standards
 */
export class PseudoLabel extends React.PureComponent<Props> {
    render() {
        return <span className={styles['pseudo-label']}>{this.props.children}</span>;
    }
}
